import React from "react";
import store from "redux/Store";
import i18next from "i18next";
import { _PermittedContent } from "_module/utils/PermittedContent";
import TrafficLightInfoBox from "_module/component/traffic-light-info-box/traffic-light-info-box";
import DiscreteTracks from "modules/ml-music-search/track/DiscreteTracks";
import PostStat from "modules/ml-music-search/track/PostStat";
import { Avatar, IconButton } from "@material-ui/core";
import { Link } from "react-router-dom";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import { BiMessageAltDetail } from "react-icons/bi";
import { Badge } from "@material-ui/core";
import HighlightedText from "util/HighlightedText";
import { LinkInterestedParties } from "util/preview-element/LinkElement";
import {
  getChangeLogDetails,
  getContributorDetails,
  userDisplay,
} from "util/CommonFunc";
import moment from "moment";
import Moment from "react-moment";
import UserDisplay from "util/UserDisplay";
import {
  editMessage,
  setEditMessageCB,
  closeMessageCB,
  setUsePopup,
} from "../messages/redux/MessagesActions";
import { _newMessage } from "../messages/Utils";
import { attachmentTypes, messageTypes } from "../messages/Const";
import { refreshItems } from "../../redux/actions/MlLicFormActions";
import { PageTableType } from "redux/Types";
import PlayerRef, {
  PlayableTypes,
} from "modules/ml-player/PlayerRef/PlayerRef";
import DownloadLink from "util/downloader/DownloadLink";
import { getUserDisplay } from "util/CommonFunc";
import DurationDisplay from "util/DurationDisplay";

export const getfilterOptions = (type) => {
  const {
    orgRuntime: {
      runtime: {
        orgSettingType: orgSettingType,
        _albumMusicOrigins: albumOrigins,
        _trackMusicOrigins: trackOrigins,
      },
    },
  } = store.getState();
  let options = [];
  switch (type) {
    case "mladminSettingsTypeOption":
      options = [
        {
          id: orgSettingType.ssearch.id,
          label: i18next.t(`modules.${orgSettingType.ssearch.id}`),
        },

        {
          id: orgSettingType.asearch.id,
          label: i18next.t(`modules.${orgSettingType.asearch.id}`),
        },

        {
          id: orgSettingType.trackmetadata.id,
          label: i18next.t(`modules.${orgSettingType.trackmetadata.id}`),
        },

        {
          id: orgSettingType.albummetadata.id,
          label: i18next.t(`modules.${orgSettingType.albummetadata.id}`),
        },
      ];
      break;
    case "mlSearchAlbumCol":
      options = Object.values(albumOrigins);
      break;
    case "mlSearchAlbumTrackCol":
    case "mlSearchTrackCol":
    case "mlLicTrackInputCol":
      options = Object.values(trackOrigins);
      break;
  }
  return options;
};

export const columnFieldConfig = (field, data, type = "track") => {
  const {
    clearanceRuntime: { runtime },
    inbox: { allUsers },
    mllicform: { items: licFormItems },
    messages: { editing: messages_Editting },
    orgRuntime: {
      runtime: {
        _trackFields: trackFields,
        _albumFields: albumFields,
        cfAllProgrammeTypes,
        cfAllTypes,
      },
    },
  } = store.getState();

  let objField = field;
  if (objField.extentedProps) {
    switch (objField.extentedProps) {
      case "trackPrsPriorApprovalIndecator":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (
              rowData &&
              (rowData["prsPriorApprovalIndecator"] ||
                rowData["prsPriorApprovalIndecator"] == 1)
            ) {
              return (
                <>
                  {/* <Avatar class="ppaLabel">R</Avatar> */}
                  <TrafficLightInfoBox
                    PriorApproval={
                      rowData["prsPriorApprovalIndecator"]
                    }></TrafficLightInfoBox>
                </>
              );
            }
          },
        };
        break;
      case "trackskyTracfficLight":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (
              rowData &&
              (rowData["skyTracfficLight"] || rowData["skyTracfficLight"] == 0)
            ) {
              return (
                <>
                  <TrafficLightInfoBox
                    data={rowData["skyTracfficLight"]}></TrafficLightInfoBox>
                </>
              );
            }
          },
        };
        break;
      case "trackPerformer":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            const {
              mltracklibrary: { postUpdating },
            } = store.getState();
            const isDiscrete =
              rowData?.discretedTracks && rowData?.discretedTracks.length > 0;
            const cTags = rowData?.cTagList?.filter(
              (r) =>
                (r.result === undefined || r.result === true) && r.indicator
            );
            const isExplicit = postUpdating || (cTags && cTags.length > 0);
            const cls =
              isDiscrete && isExplicit
                ? "DiscreteExplicitFlags"
                : isDiscrete
                  ? "DiscreteFlag"
                  : isExplicit
                    ? "ExplicitFlag"
                    : "NoFlags";
            const cTagClasses =
              cls +
              (cTags && cTags.length > 0
                ? ` cTags${cTags.length > 3 ? 3 : cTags.length}`
                : "");

            return (
              <>
                <span className={cTagClasses}>
                  <strong>
                    <h3 class="trackAccTitle">
                      {HighlightedText(rowData, trackFields.performer.id)}
                    </h3>
                  </strong>
                  {/* <span class="discreteTracks">
                    {rowData?.discretedTracks &&
                    rowData?.discretedTracks.length > 0 ? (
                      <DiscreteTracks track={rowData} />
                    ) : null}{" "}
                  </span> 
                  <PostStat track={rowData} postUpdating={postUpdating} />*/}
                </span>
              </>
            );
          },
        };
        break;
      case "trackLyricist":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.lyricist.id]
                ? rowData?.highlights[trackFields.lyricist.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="lyricist"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackAdaptor":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights && rowData?.highlights[trackFields.adaptor.id]
                ? rowData?.highlights[trackFields.adaptor.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="adaptor"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackAdministrator":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.administrator.id]
                ? rowData?.highlights[trackFields.administrator.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="administrator"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackArranger":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.arranger.id]
                ? rowData?.highlights[trackFields.arranger.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="arranger"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackComposer":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.composer.id]
                ? rowData?.highlights[trackFields.composer.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="composer"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackPublisher":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.publisher.id]
                ? rowData?.highlights[trackFields.publisher.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="publisher"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackOriginalPublisher":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.originalPublisher.id]
                ? rowData?.highlights[trackFields.originalPublisher.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="originalPublisher"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackSubLyricist":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.subLyricist.id]
                ? rowData?.highlights[trackFields.subLyricist.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="subLyricist"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackSubAdaptor":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.subAdaptor.id]
                ? rowData?.highlights[trackFields.subAdaptor.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="subAdaptor"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackSubPublisher":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.subPublisher.id]
                ? rowData?.highlights[trackFields.subPublisher.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="subPublisher"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumProdArtist":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.prodArtist.id]
                ? rowData?.highlights[albumFields.prodArtist.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="prodArtist"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackPerformer":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackPerformer.id]
                ? rowData?.highlights[albumFields.trackPerformer.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackPerformer"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackLyricist":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackLyricist.id]
                ? rowData?.highlights[albumFields.trackLyricist.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackLyricist"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackComposerLyricist":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackComposerLyricist.id]
                ? rowData?.highlights[albumFields.trackComposerLyricist.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackComposerLyricist"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackAdaptor":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackAdaptor.id]
                ? rowData?.highlights[albumFields.trackAdaptor.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackAdaptor"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackAdministrator":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackAdministrator.id]
                ? rowData?.highlights[albumFields.trackAdministrator.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackAdministrator"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackArranger":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackArranger.id]
                ? rowData?.highlights[albumFields.trackArranger.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackArranger"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackComposer":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackComposer.id]
                ? rowData?.highlights[albumFields.trackComposer.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackComposer"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackPublisher":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackPublisher.id]
                ? rowData?.highlights[albumFields.trackPublisher.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackPublisher"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackOriginalPublisher":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackOriginalPublisher.id]
                ? rowData?.highlights[albumFields.trackOriginalPublisher.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackOriginalPublisher"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackSubLyricist":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackSubLyricist.id]
                ? rowData?.highlights[albumFields.trackSubLyricist.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackSubLyricist"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackSubAdaptor":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackSubAdaptor.id]
                ? rowData?.highlights[albumFields.trackSubAdaptor.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackSubAdaptor"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackSubArranger":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackSubArranger.id]
                ? rowData?.highlights[albumFields.trackSubArranger.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackSubArranger"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackSubPublisher":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackSubPublisher.id]
                ? rowData?.highlights[albumFields.trackSubPublisher.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackSubPublisher"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "albumTrackTranslator":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[albumFields.trackTranslator.id]
                ? rowData?.highlights[albumFields.trackTranslator.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="trackTranslator"
                  type="albums"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackTranslator":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let highlights =
              rowData?.highlights &&
                rowData?.highlights[trackFields.translator.id]
                ? rowData?.highlights[trackFields.translator.id]
                : null;
            return (
              <>
                <LinkInterestedParties
                  highlights={highlights}
                  rowData={rowData}
                  field="translator"
                  type="tracks"></LinkInterestedParties>
              </>
            );
          },
        };
        break;
      case "trackContributorsExtended":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            return rowData && rowData?.contributorsExtended
              ? getContributorDetails(rowData?.contributorsExtended)
              : "";
          },
          cellProp: (rowData) => {
            return {
              accessDataProps: {
                title: " ",
              },
            };
          },
        };
        break;
      case "trackChangeLog":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            return rowData && rowData?.changeLog
              ? getChangeLogDetails(rowData?.changeLog)
              : "";
          },
          cellProp: (rowData) => {
            return {
              accessDataProps: {
                title: " ",
              },
            };
          },
        };
        break;
      case "trackScore":
      case "albumScore":
        objField = {
          ...objField,
          cellRenderer: (rowData) => (
            <strong
              title={
                rowData?.scoreExp
                  ? JSON.stringify(rowData?.scoreExp)
                  : "Unexplained"
              }>
              {rowData?.score || "--"}
            </strong>
          ),
        };
        break;
      case "trackmlCreated":
        objField = {
          ...objField,
          cellRenderer: (rowData) => (
            <span>{rowData?.mlCreated ? "Yes" : "No"}</span>
          ),
        };
        break;
      case "trackcTagMcpsOwner":
        objField = {
          ...objField,
          cellRenderer: (rowData) => <span>{rowData?.cTagMcpsOwner}</span>,
        };
        break;
      case "trackcTagNorthAmerican":
        objField = {
          ...objField,
          cellRenderer: (rowData) => <span>{rowData?.cTagNorthAmerican}</span>,
        };
        break;
      case "trackDuration":
        objField = {
          ...objField,
          cellRenderer: (rowData) => (
            <DurationDisplay seconds={rowData?.duration} />
          ),
        };
        break;
      case "trackPlayer":
        objField = {
          ...objField,
          artworkField: trackFields.prodArtworkUrl.id,
          cellProp: (rowData) => {
            return {
              artworkProps: {
                alt: `Art work for ${rowData ? rowData[trackFields.trackTitle.id] : ""
                  }`,
              },
              playerProps: {
                ariaLabel: `Play track ${rowData?.trackTitle}`,
              },
            };
          },
        };
        break;
      case "trackDownloader":
        objField = {
          ...objField,
          artworkField: trackFields.downloader.id,
          cellRenderer: (rowData) => <DownloadLink track={rowData} />,
        };
        break;
      case "albumPlayer":
        objField = {
          ...objField,
          // cellRenderer: (rowData) => (
          //   <PlayerRef
          //     key={rowData?.id}
          //     ariaLabel={`Play album ${rowData?.prodName}`}
          //     item={rowData}
          //     playableType={PlayableTypes.album}
          //     popoutFor={PageTableType.SEARCH_ALBUM_TRACKS}
          //   />
          // ),
          artworkField: albumFields.prodArtworkUrl.id,
          // cellProp: (rowData) => {
          //   return {
          //     artworkProps: {
          //       alt: `Art work for ${rowData[albumFields.prodName.id]}`,
          //     },
          //   };
          // },
          cellProp: (rowData) => {
            return {
              artworkProps: {
                alt: `Art work for ${rowData ? rowData[albumFields.prodName.id] : ""
                  }`,
              },
              playerProps: {
                ariaLabel: `Play album ${rowData?.prodName}`,
                key: rowData?.id,
                item: rowData,
                playableType: PlayableTypes.album,
                popoutFor: PageTableType.SEARCH_ALBUM_TRACKS,
              },
            };
          },
        };
        break;
      case "trackTitle":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            const {
              mltracklibrary: { postUpdating },
            } = store.getState();
            const isDiscrete =
              rowData?.discretedTracks && rowData?.discretedTracks.length > 0;
            const cTags = rowData?.cTagList?.filter(
              (r) =>
                (r.result === undefined || r.result === true) && r.indicator
            );
            const isExplicit = postUpdating || (cTags && cTags.length > 0);
            const cls =
              isDiscrete && isExplicit
                ? "DiscreteExplicitFlags"
                : isDiscrete
                  ? "DiscreteFlag"
                  : isExplicit
                    ? "ExplicitFlag"
                    : "NoFlags";
            const cTagClasses =
              cls +
              (cTags && cTags.length > 0
                ? ` cTags${cTags.length > 3 ? 3 : cTags.length}`
                : "");
            return (
              <>
                <span id="tracknewTitle" className={cTagClasses}>
                  <strong>
                    <h3 class="trackAccTitle">
                      {HighlightedText(rowData, trackFields.trackTitle.id)}
                    </h3>
                  </strong>
                  {rowData?.prodHide ? <span title="Album Hidden" class="hiddenItem"> H</span> :
                    rowData?.hide ? <span title="Media Hidden" class="hiddenItem"> H</span> : null
                  }
                  {/* <span class="discreteTracks">
                    {rowData?.discretedTracks &&
                    rowData?.discretedTracks.length > 0 ? (
                      <DiscreteTracks track={rowData} />
                    ) : null}{" "}
                  </span>
                  <PostStat track={rowData} postUpdating={postUpdating} /> */}
                </span>
              </>
            );
          },
        };
        break;
      case "trackVersionTitle":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            const {
              mltracklibrary: { postUpdating },
            } = store.getState();
            const isDiscrete =
              rowData?.discretedTracks && rowData?.discretedTracks.length > 0;
            const cTags = rowData?.cTagList?.filter(
              (r) =>
                (r.result === undefined || r.result === true) && r.indicator
            );
            const isExplicit = postUpdating || (cTags && cTags.length > 0);
            const cls =
              isDiscrete && isExplicit
                ? "DiscreteExplicitFlags"
                : isDiscrete
                  ? "DiscreteFlag"
                  : isExplicit
                    ? "ExplicitFlag"
                    : "NoFlags";
            const cTagClasses =
              cls +
              (cTags && cTags.length > 0
                ? ` cTags${cTags.length > 3 ? 3 : cTags.length}`
                : "");
            return (
              <>
                <span className={cTagClasses}>
                  <strong>
                    <h3 class="trackAccTitle">
                      {HighlightedText(
                        rowData,
                        trackFields.trackVersionTitle.id
                      )}
                    </h3>
                  </strong>
                  <span class="discreteTracks">
                    {rowData?.discretedTracks &&
                      rowData?.discretedTracks.length > 0 ? (
                      <DiscreteTracks track={rowData} />
                    ) : null}{" "}
                  </span>
                  <PostStat track={rowData} postUpdating={postUpdating} />
                </span>
              </>
            );
          },
        };
        break;
      case "trackProdName":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (rowData?.is_mcf_track == true || rowData?.mlCreated == true) {
              return <strong class="tablesLink">
                {HighlightedText(rowData, trackFields.prodName.id)}
              </strong>
            } else {
              return <Link
                style={{ textDecoration: "none", color: "#fff" }}
                key={rowData?.prodId}
                aria-label={rowData?.prodName}
                to={{
                  pathname: `/search/album/${rowData?.prodId}`,
                  state: { searchId: rowData?.searchId },
                }}>
                <strong class="tablesLink">
                  {HighlightedText(rowData, trackFields.prodName.id)}
                </strong>
              </Link>
            }
          },
        };
        break;
      case "albumProdName":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (rowData?.is_mcf_track == true || rowData?.mlCreated == true) {
              return <strong class="tablesLink">
                <h3 class="trackAccTitle">
                  {HighlightedText(rowData, albumFields.prodName.id)}
                </h3>
              </strong>
            } else {
              return (
                <>
                  <span id="albumnewTitle">
                    <Link
                      style={{ textDecoration: "none", color: "#fff" }}
                      key={rowData?.id}
                      to={{
                        pathname: `/search/album/${rowData?.prodId}`,
                        state: { searchId: rowData?.searchId },
                      }}
                      aria-label={rowData?.prodName}>
                      <strong class="tablesLink">
                        <h3 class="trackAccTitle">
                          {HighlightedText(rowData, albumFields.prodName.id)}
                        </h3>
                      </strong>

                    </Link>
                    {rowData?.hide && (
                      <span title="Album Hidden" class="hiddenItem"> H</span>
                    )}
                  </span>
                </>
              )

            }
          },
        };
        break;
      case "trackMusicOrigin":
        objField = {
          ...objField,
          filterOptions: getfilterOptions("mlSearchTrackCol"),
        };
        break;
      case "albumMusicOrigin":
        objField = {
          ...objField,
          filterOptions: getfilterOptions("mlSearchAlbumCol"),
        };
        break;
      case "createdAt":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (rowData[runtime?._config?.MIGRATED_FLAG]) {
              return (
                <Moment
                  key={rowData?.id}
                  format="DD/MM/YYYY"
                  titleFormat="DD/MM/YYYY"
                  withTitle>
                  {rowData?.mlData?.createdAt}
                </Moment>
              );
            } else {
              return (
                <Moment
                  key={rowData?.id}
                  format="DD/MM/YYYY"
                  titleFormat="DD/MM/YYYY"
                  withTitle>
                  {rowData?.createdAt}
                </Moment>
              );
            }
          },
          cellProp: (rowData) => {
            return {
              accessDataProps: {
                title: rowData?.createdAt
                  ? moment(rowData?.createdAt).format("DD/MM/YYYY")
                  : "",
              },
            };
          },
        };
        break;
      case "updatedAt":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (rowData[runtime?._config?.MIGRATED_FLAG]) {
              return (
                <Moment
                  key={rowData?.id}
                  format="DD/MM/YYYY"
                  titleFormat="DD/MM/YYYY"
                  withTitle>
                  {rowData?.mlData?.updatedAt}
                </Moment>
              );
            } else {
              return (
                <Moment
                  key={rowData?.id}
                  format="DD/MM/YYYY"
                  titleFormat="DD/MM/YYYY"
                  withTitle>
                  {rowData?.updatedAt}
                </Moment>
              );
            }
          },
          cellProp: (rowData) => {
            return {
              accessDataProps: {
                title: rowData?.updatedAt
                  ? moment(rowData?.updatedAt).format("DD/MM/YYYY")
                  : "",
              },
            };
          },
        };
        break;
      case "cfCreatedBy":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (rowData[runtime?._config?.MIGRATED_FLAG]) {
              return `${rowData?.mlData?.createdByTitle} ${rowData?.mlData?.createdByFirstName} ${rowData?.mlData?.createdByLastName}`;
            } else {
              return <UserDisplay userId={rowData?.createdBy} />;
            }
          },
          cellProp: (rowData) => {
            return (
              {
                filterProps: {
                  ariaLable: `Select user`,
                },
              },
              {
                accessDataProps: {
                  title: `${userDisplay(rowData?.createdBy)}`,
                },
              }
            );
          },
        };
        break;
      case "updatedBy":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (rowData[runtime?._config?.MIGRATED_FLAG]) {
              return `${rowData?.mlData?.createdByTitle} ${rowData?.mlData?.createdByFirstName} ${rowData?.mlData?.createdByLastName}`;
            } else {
              return <UserDisplay userId={rowData?.updatedBy} />;
            }
          },
          cellProp: (rowData) => {
            return (
              {
                filterProps: {
                  ariaLable: `Select user`,
                },
              },
              {
                accessDataProps: {
                  title: `${userDisplay(rowData?.updatedBy)}`,
                },
              }
            );
          },
        };
        break;
      case "cfFields":
        objField = {
          ...objField,
          cellRenderer: (rowData) => (
            <>
              <IconButton
                aria-label="Load Message"
                className={"clearanceButtonMargin"}
                onClick={(e) => {
                  loadMessage(e, rowData);
                }}
                disabled={
                  (messages_Editting &&
                    rowData?.messageid &&
                    messages_Editting?.id === rowData?.messageid) ||
                  (!rowData?.messageid && !canShareCF(rowData))
                }>
                <Badge
                  class="clIconsmsg"
                  color="secondary"
                  variant="dot"
                  invisible={rowData?.messageid ? false : true}>
                  <EmailOutlinedIcon />
                </Badge>
              </IconButton>
            </>
          ),
        };
        break;
      case "cfProdName_Series":
        objField = {
          ...objField,
          cellRenderer: (rowData) => (
            <Link
              aria-label={`Open ${rowData?.name} clearance form`}
              style={{ textDecoration: "none", color: "#fff" }}
              key={rowData?.id}
              to={`/mllicensingforms/${rowData?.id}`}
              onClick={(event) => {
                if (objField?.disableLink) {
                  event.preventDefault();
                }
              }}>
              <strong class={objField?.disableLink ? "" : "tablesLink"}>
                <h3 class="trackAccTitle">
                  {rowData?.name}{" "}
                  {rowData?.tracksCount ? `(${rowData?.tracksCount})` : null}
                </h3>
              </strong>
            </Link>
          ),
          cellProp: (rowData) => {
            return {
              filterProps: {
                ariaLable: `Enter clearance form name`,
              },
            };
          },
        };
        break;
      case "cfProgrameType":
        objField = {
          ...objField,
          cellRenderer: (rowData) => (
            <span>
              {
                (runtime &&
                  runtime._config &&
                  runtime._config.PROGRAMME_TYPES_LIST
                  ? runtime._config.PROGRAMME_TYPES_LIST
                  : cfAllProgrammeTypes
                ).find((d) => d.value == rowData?.programmeType)?.text
              }
            </span>
          ),
          filterOptions: (runtime &&
            runtime._config &&
            runtime._config.PROGRAMME_TYPES_LIST
            ? runtime._config.PROGRAMME_TYPES_LIST
            : cfAllProgrammeTypes
          )
            .filter((d) =>
              runtime?._config?.EXCLUDE_CF_EPISODES_FROM_SERACH
                ? d?.value !== runtime?._config?.PROGRAMME_TYPES.EPISODE
                : true
            )
            .map((d) => {
              return {
                ...d,
                id: d.value,
                label: d.text,
              };
            }),
        };
        break;
      // case "cfFormType":
      //   objField = {
      //     ...objField,
      //     cellRenderer: (rowData) => (
      //       <span>{(runtime && runtime._config && runtime._config.CLEARANCE_FORM_TYPE_LIST ? runtime._config.CLEARANCE_FORM_TYPE_LIST : cfAllTypes).find(d => d.value == rowData?.clearanceFormType)?.label}</span>
      //     ),
      //     filterOptions: (runtime && runtime._config && runtime._config.CLEARANCE_FORM_TYPE_LIST ? runtime._config.CLEARANCE_FORM_TYPE_LIST : cfAllTypes).map(d => {
      //       return {
      //         ...d,
      //         id: d.value,
      //         label: d.text || d.label
      //       }
      //     }),
      //   }
      //   break;
      case "trackCreatedBy":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            return getUserDisplay(String(rowData?.trackCreatedBy));
          },
        };
        break;
      case "trackLastEditedBy":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            return getUserDisplay(String(rowData?.trackLastEditedBy));
          },
        };
        break;
      case "createdBy":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            return getUserDisplay(String(rowData?.createdBy));
          },
        };
        break;
      case "lastEditedBy":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            return getUserDisplay(String(rowData?.lastEditedBy));
          },
        };
        break;
      case "prodCreatedBy":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            return getUserDisplay(String(rowData?.prodCreatedBy));
          },
        };
        break;
      case "prodLastEditedBy":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            return getUserDisplay(String(rowData?.prodLastEditedBy));
          },
        };
        break;

      case "cfFormType":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            if (rowData[runtime?._config?.MIGRATED_FLAG]) {
              return (
                <span>
                  {(runtime?._config?.CF_PROGRAMME_AND_FORM_TYPE_LIST
                    ? runtime?._config?.CF_PROGRAMME_AND_FORM_TYPE_LIST
                    : cfAllTypes
                  ).find((d) => d.value == rowData?.cfProgrammeAndFormType)
                    ?.label ||
                    (runtime?._config?.CLEARANCE_FORM_TYPE_LIST
                      ? runtime?._config?.CLEARANCE_FORM_TYPE_LIST
                      : cfAllTypes
                    ).find(
                      (d) =>
                        d.value == rowData?.cfProgrammeAndFormType.split("-")[0]
                    )?.label}
                </span>
              );
            } else {
              return (
                <span>
                  {
                    (runtime?._config?.CF_PROGRAMME_AND_FORM_TYPE_LIST
                      ? runtime?._config?.CF_PROGRAMME_AND_FORM_TYPE_LIST
                      : cfAllTypes
                    ).find((d) => d.value == rowData?.cfProgrammeAndFormType)
                      ?.label
                  }
                </span>
              );
            }
          },
          filterOptions: (runtime &&
            runtime._config &&
            runtime._config.CF_PROGRAMME_AND_FORM_TYPE_LIST
            ? runtime._config.CF_PROGRAMME_AND_FORM_TYPE_LIST
            : cfAllTypes
          ).map((d) => {
            return {
              ...d,
              id: d.value,
              label: d.text || d.label,
            };
          }),
        };
        break;
      case "IsMCPSBlanket":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let value =
              rowData?.org_sky_IsMCPSBlanket == true ? "" : "Non-MCPS";
            return <span>{value}</span>;
          },
        };
        break;
      case "IsPPLBlanket":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let value = rowData?.org_sky_IsPPLBlanket == true ? "" : "Non-PPL";
            return <span>{value}</span>;
          },
        };
        break;
      case "prodIsMCPSBlanket":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let value =
              rowData?.org_sky_prodIsMCPSBlanket == true ? "" : "Non-MCPS";
            return <span>{value}</span>;
          },
        };
        break;
      case "prodIsPPLBlanket":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            let value =
              rowData?.org_sky_prodIsPPLBlanket == true ? "" : "Non-PPL";
            return <span>{value}</span>;
          },
        };
        break;
      case "skyPPL":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            // let value = rowData?.org_sky_PPL == true ? "No" : "Yes";
              let value = rowData?.org_sky_PPL == true ? "Yes" : "Non-PPL";
            return <span>{value}</span>;
          },
        };
        break;
      case "skyMCPS":
        objField = {
          ...objField,
          cellRenderer: (rowData) => {
            // let value = rowData?.org_sky_MCPS == true ? "No" : "Yes";
            let value = rowData?.org_sky_MCPS == true ? "Yes" : "Non-MCPS";
            return <span>{value}</span>;
          },
        };
        break;
      default:
        break;
    }
  }

  return objField;
};

const loadMessage = (e, rowData) => {
  e.stopPropagation();

  const {
    inbox: { allUsers },
    mllicform: { items },
  } = store.getState();

  store.dispatch(setUsePopup(true));

  if (rowData?.messageid) {
    store.dispatch(setEditMessageCB(null));
    store.dispatch(editMessage({ id: rowData?.messageid }));
    store.dispatch(refreshItems(items));
    store.dispatch(
      closeMessageCB((closed) => {
        if (closed) {
          store.dispatch(refreshItems(items));
        }
      })
    );
  } else {
    store.dispatch(refreshItems(items));
    store.dispatch(
      setEditMessageCB((id) => {
        let index = items.findIndex((v) => v.id === rowData?.id);
        let nitems = [...items];
        if (index >= 0) {
          nitems[index].messageid = id;
          store.dispatch(refreshItems(nitems));
        }
      })
    );

    store.dispatch(
      editMessage(
        _newMessage(
          messageTypes.CLEARANCE_FORM,
          getAttachment(rowData),
          rowData?.name,
          "",
          // [rowData?.createdBy],
          []
          // [defaultGroups.CLEARANCE_GROUP]
        )
      )
    );
  }
};

const getAttachment = (rowData) => {
  let attachment = [];
  // if(canShareCF(rowData)){
  attachment = [
    {
      id: rowData?.id,
      name: rowData?.name,
      tracksCount: rowData?.tracksCount,
      artwork: null,
      type: attachmentTypes.CLEARANCE_FORM,
    },
  ];
  // }
  return attachment;
};

const canShareCF = (cf) => {
  const {
    user: { id: userId },
    orgRuntime: {
      runtime: {
        _mlLicensing,
        _mlLicensingCanShareCF,
        _mlLicensingCanShareCFOptions,
      },
    },
  } = store.getState();

  let cfSharePermission =
    _PermittedContent([_mlLicensing, _mlLicensingCanShareCF], []) ??
    _mlLicensingCanShareCF.default;

  switch (cfSharePermission) {
    case _mlLicensingCanShareCFOptions.all.id:
      return true;
    case _mlLicensingCanShareCFOptions.own.id:
      return cf?.createdBy === userId;
    case _mlLicensingCanShareCFOptions.none.id:
    default:
      return false;
  }
};
